import * as React from 'react';
import { useTranslation } from 'next-i18next';
import tw from 'twin.macro';
import { useAtom } from 'jotai';
import { TrashIcon } from '@heroicons/react/24/solid';

import { Link, Title } from '@restworld/ui-ds';

import { showContactRestWorldManagerModalAtom } from '../restaurants/employer-restaurants-filters/employer-restaurants.atoms';

export const UserDeleteAction = () => {
  const [, setShowContactRestworldManagerModal] = useAtom(showContactRestWorldManagerModalAtom);
  const { t } = useTranslation('user-settings');

  const onDelete = React.useCallback(() => {
    setShowContactRestworldManagerModal(true);
  }, [setShowContactRestworldManagerModal]);
  return (
    <div className="flex-col justify-start items-start gap-2 inline-flex">
      <Link twStyle={tw`self-start`} StartIcon={TrashIcon} onClick={onDelete} newTab={false} variant="error">
        {t('delete_account_title')}
      </Link>
      <Title
        fontSize="small"
        fontWeight="medium"
        content={t('account_deletion_note')}
        twStyle={tw`self-stretch text-neutral-100`}
      />
    </div>
  );
};
